import GridView from '../../components/controls/GridView/GridView';
import locationService from '../../services/locationService';
import classes from './location-listing-page.module.css';

export interface LocationListingPageProps { }

function LocationListingPage(props: LocationListingPageProps) {

	return (
		<div className='row'>
			<div className="col">
				<h3>Locations</h3>
				<GridView
					name='lstLocations'
					rowsPerPage={50}
				/>
			</div>
		</div>
	);
}

export default LocationListingPage;